export default "__VITE_ASSET__53ee588b__"